module.exports = __webpack_public_path__ + "img/graphical_upgrade_after.0f007c5.png";